import React, { useRef, useState } from 'react'
import RotatingText from '../common/RotatingText'
import { motion,useMotionValue, useSpring } from 'framer-motion'
import { Link } from 'react-router-dom'

function MagneticRoundButton({ text, src, to, radius, size }) {

    var imageHeightWidth = radius * 1.8

    const [isHovering, setIsHovering] = useState(false)
    const [origin, setOrigin] = useState("50% 50%")


    const ref = useRef(null);

    const x = useMotionValue(0);
    const y = useMotionValue(0);

    const springX = useSpring(x, {
        stiffness: 200,
        damping: 20
    });


    const springY = useSpring(y, {
        stiffness: 200,
        damping: 20
    });

    const handleMouseMove = (e) => {
        if (!ref.current) return;

        const rect = ref.current.getBoundingClientRect();

        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const distanceX = e.clientX - centerX;
        const distanceY = e.clientY - centerY;

        const strength = 0.5;

        x.set(-(distanceX * strength));
        y.set(-(distanceY * strength));
    }

    const handleMouseLeave = () => {
        x.set(0);
        y.set(0);
    }



    const handleMouseEnter = (e) => {

        setIsHovering(true)
        const rect = e.currentTarget.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        if (x < centerX && y < centerY) {
            setOrigin("0% 0%")
        }
        else if (x > centerX && y < centerY) {
            setOrigin("100% 0%")
        }
        else if (x < centerX && y > centerY) {
            setOrigin("0% 100%")
        }
        else {
            setOrigin("100% 100%")
        }

    }
    return (
        <motion.div

            ref={ref}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}


            style={{
                x: springX,
                y: springY
            }}

            className='relative w-[220px] h-[220px]'
        >
            <Link to={to}>

                <RotatingText
                    text={text}
                    radius={radius}
                    size={size}
                />
                <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={() => setIsHovering(false)}
                    style={{
                        width: imageHeightWidth,
                        height: imageHeightWidth,
                        transform: "translate(-50%, -50%)"
                    }}
                    className={`${isHovering ? 'border-0' : 'border border-black/30'} rounded-full overflow-hidden absolute top-1/2 left-1/2`}>

                    <motion.img
                        className={`rounded-full `}
                        src={src} alt=""
                        animate={{
                            scale: isHovering ? 1 : 0
                        }}
                        transition={{
                            type: "spring",
                            stiffness: 150,
                            damping: 15,
                            mass: 0.7

                        }}
                        style={
                            {
                                transformOrigin: origin
                            }
                        }
                    />
                </div>
            </Link>
        </motion.div>
    )
}

export default MagneticRoundButton